import { UserRepository } from '@/interfaces/repositories/users';
import { FirebaseAuthenticationService } from '@/services/authentication/firebaseAuthenticationService';
import { AuthenticationService } from '@/services/authentication/interfaces';

import { useLoggingService } from '../logging/composable';

let authenticationService: AuthenticationService | null = null;

export function useAuthenticationService(options?: {
  serviceInstance?: AuthenticationService;
  getUserRepository?: () => UserRepository;
}): AuthenticationService {
  if (options?.serviceInstance) {
    authenticationService = options.serviceInstance;
    return options.serviceInstance;
  }

  if (!authenticationService) {
    authenticationService = new FirebaseAuthenticationService(
      useLoggingService(),
      options?.getUserRepository ??
        (() => {
          throw new Error('User repository not available yet');
        }),
    );
  }
  return authenticationService;
}
